import React, {Component} from "react"
import PropTypes from "prop-types"
import {Row} from "react-bootstrap"

import {injectIntl} from "@irati/utils/lang"
import ToggleTagOnCommentMutation from "@irati/insights/apollo/mutation/comment/toggleTag"

import {Input} from "../../ui/FormItem"
import Modal from "../../ui/Modal"


const MAX_BOOKMARK_LENGTH = 50

class AddBookmarkModal extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    comment: PropTypes.object.isRequired
  }

  state = {
    bookmarkText: "",
    isOpen: false
  }

  toggleModal = () => {
    this.setState({isOpen: !this.state.isOpen, bookmarkText: ""})
  }

  handleInputChange = (bookmarkText) => {
    this.setState({bookmarkText})
  }

  resetState = () => {
    this.setState({
      isOpen: false,
      bookmarkText: ""
    })
  }

  handleBookmarkToggle = (toggleTag) => {
    toggleTag()
    this.resetState()
  }

  render() {
    const {formatMessage, comment} = this.props
    const {bookmarkText, isOpen} = this.state
    return (
      <ToggleTagOnCommentMutation note={bookmarkText} comment={comment}>
        {(toggleTag) => {
          return (
            <Modal
              primary={{
                onClick: () => this.handleBookmarkToggle(toggleTag),
                text: formatMessage({id: "insights.comments.bookmark.modal.addCta"})
              }}
              secondary={{onClick: this.toggleModal, text: formatMessage({id: "insights.comments.bookmark.modal.cancelCta"})}}
              show={isOpen}
              handleClose={this.toggleModal}
              title={formatMessage({id: "insights.bookmarks.createModal.title"})}>
              <Row>
                <Input
                  name="insights.bookmarks.createModal.inputLabel"
                  wide
                  label="insights.bookmarks.createModal.inputLabel"
                  type="text"
                  placeholder="insights.bookmarks.createModal.inputPlaceholder"
                  value={bookmarkText}
                  onChange={this.handleInputChange}
                  maxLength={MAX_BOOKMARK_LENGTH} />
              </Row>
            </Modal>
          )
        }}
      </ToggleTagOnCommentMutation>
    )
  }
}

export default injectIntl(AddBookmarkModal, {withRef: true})
